
import { defineComponent } from 'vue';
import moment from 'moment-timezone';
import DeleteIcon from '~/components/common/icons/Trash.vue';

export default defineComponent({
  name: 'BMobileCartItem',
  components: {
    DeleteIcon
  },
  props: {
    ticketData: {
      type: Object,
      default: () => ({
        id: 0,
        name: '',
        price: 0,
        currency: '',
        discountName: '',
        seatId: '',
        occurrence: null,
        timeslot: null,
        occurrenceName: '',
        occurrenceStartAt: null,
        occurrenceEndAt: null,
        timeslotName: '',
        timeslotStartAt: null,
        timeslotEndAt: null
      })
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove'],
  computed: {
    /**
     * Compute the formatted price with 2 decimal places
     */
    formattedPrice(): string {
      return this.ticketData.price.toFixed(2);
    },
    isRecurringOrHasTimeslots() {
      return this.ticketData.occurrenceName || this.ticketData.timeslotName;
    },
    startDate() {
      let eventStartDate;
      if (this.ticketData.timeslotStartAt) {
        eventStartDate = this.ticketData.timeslotStartAt;
      } else if (this.ticketData.occurrenceStartAt) {
        eventStartDate = this.ticketData.occurrenceStartAt;
      }
      const startDate = moment.parseZone(new Date(eventStartDate)).toDate();
      return {
        date: this.$d(startDate, 'DD_MM_YYYY'),
        time: this.$d(startDate, 'HH_mm')
      };
    },
    endDate() {
      let eventEndDate;
      if (this.ticketData.timeslotEndAt) {
        eventEndDate = this.ticketData.timeslotEndAt;
      } else if (this.ticketData.occurrenceEndAt) {
        eventEndDate = this.ticketData.occurrenceEndAt;
      }
      const endDate = moment.parseZone(new Date(eventEndDate)).toDate();
      return {
        date: this.$d(endDate, 'DD_MM_YYYY'),
        time: this.$d(endDate, 'HH_mm')
      };
    },
    onSameDay() {
      return this.startDate.date === this.endDate.date;
    }
  },

  methods: {
    /**
     * Emit the 'remove' event when the delete button is clicked
     */
    deleteTicket() {
      this.$emit('remove');
    }
  }
});
